const Games = () => {
    return <div className="games">

    </div>;
}

export default Games;